import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'shared-image-upload',
  standalone: true,
  imports: [CommonModule, TranslocoModule],
  templateUrl: './image-upload.component.html',
  styleUrl: './image-upload.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageUploadComponent {

  // @Input() doubleUploadType: boolean = false;
  @Input() labelName: any = '';
  @Input() imageCounter: any;
  @Input() selectedFiles: any;
  @Input() cssClass: any;
  @Input() previewLabelName: any = '';
  @Input() visible = true;
  @Input() requiredStar = false;
  @Input() previewData: any;
  @Input() fileInput: any = 'fileInput'
  @Input() isZipOnly: any = false;
  @Input() isMultiple: any = false;
  @Output() uploadedFileData = new EventEmitter<any>();
  uploadErrorMsg: any;
  // selectedFiles:any;

  // constructor() { }

  private processFile(file: any): void {
    console.log("processFile", file);

    if (this.isZipOnly) {
      if (this.isMultiple) {
        const invalidFiles = Array.from(file as FileList).filter(
          (f: File) =>
            !(
              f.type === 'application/zip' ||
              f.type === 'application/x-zip-compressed' ||
              f.name.toLowerCase().endsWith('.zip')
            )
        );
        if (invalidFiles.length > 0) {
          this.uploadErrorMsg = 'All files must be ZIP format (.zip).';
          return;
        }
      } else {
        const zipFile = file as File;
        const isZip =
          zipFile.type === 'application/zip' ||
          zipFile.type === 'application/x-zip-compressed' ||
          zipFile.name.toLowerCase().endsWith('.zip');

        if (!isZip) {
          this.uploadErrorMsg = 'Only ZIP files are allowed.';
          return;
        }
      }
    } else {
      if (!file.type.startsWith('image/')) {
        this.uploadErrorMsg = 'Only image allowed.';
        return;
      }

      // Optional: Validate file size (e.g., max 2MB)
      const maxSize = 2 * 1024 * 1024; // 2MB
      if (file.size > maxSize) {
        this.uploadErrorMsg = `File size should be less than 2MB. Current size: ${(file.size / 1024 / 1024).toFixed(2)}MB.`;
        return;
      }
    }

    this.selectedFiles = [file]; // Store the selected file in an array
    const Docs = [{ file, doctype: 1 }];
    this.uploadedFileData.emit(Docs); // Emit the selected file data

    // this.previewData = [];
    // const reader = new FileReader();
    // reader.onload = (e: any) => {
    //   this.previewData.push({ url: e.target.result, name: Docs[0]?.file.name });
    //   this.#cdr.detectChanges();
    // };
    // reader.readAsDataURL(Docs[0]?.file);
  }

  uploadedFile(event: Event): void {
    this.uploadErrorMsg = '';
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return; // If no file is selected, exit the function
    const file: any = this.isMultiple ? input.files : input.files[0];
    this.processFile(file); // Delegate to common file processing logic
    input.value = '';
  }

  // Handle file selection via drag-and-drop
  onDrop(event: DragEvent): void {
    event.preventDefault(); // Prevent default behavior (file opening)
    event.stopPropagation(); // Stop event from bubbling

    const files = event.dataTransfer?.files;
    if (!files || files.length === 0) return; // If no files are dropped, exit the function

    // const file = files[0];
    const file: any = this.isMultiple ? files : files[0];
    this.processFile(file); // Delegate to common file processing logic
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault(); // Allow drop
    event.stopPropagation();
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
  }


  // removeImage(index: number): void {
  //   this.previewData.splice(index, 1);
  //   this.selectedFiles.splice(index, 1);
  //   this.#cdr.detectChanges();
  // }
}
